export const ScrollTo = {
  mounted() {
    const selector = this.el.getAttribute("data-scroll-to");

    if (selector) {
      const el = document.querySelector(selector);

      if (el) {
        const behavior = this.el.hasAttribute("data-scroll-smooth") ? "smooth" : "auto";

        window.requestAnimationFrame(() => {
          el.scrollIntoView({
            inline: "nearest",
            block: "center",
            behavior,
          });
        });
      }
    }
  },
};
